import type { AnalyticsPeriodKey, ExpertReferralIndicators } from "@expertloop/shared";
import { AdminApiError, adminApi } from "../../services/api";

/**
 * Indicateurs du parrainage entre experts (lot E6). Programme éteint, la route
 * n'existe pas : la page le dit, au lieu d'afficher une panne.
 */
export type ExpertReferralIndicatorsResult =
	| { enabled: true; indicators: ExpertReferralIndicators }
	| { enabled: false };

export const expertReferralsApi = {
	indicators: async (period: AnalyticsPeriodKey, referrerId: string | null): Promise<ExpertReferralIndicatorsResult> => {
		const query = new URLSearchParams({ period });
		if (referrerId) query.set("referrerId", referrerId);
		try {
			const indicators = await adminApi.get<ExpertReferralIndicators>(`/admin/analytics/expert-referrals?${query.toString()}`);
			return { enabled: true, indicators };
		} catch (error) {
			if (error instanceof AdminApiError && error.status === 404) return { enabled: false };
			throw error;
		}
	},
};
